import axios from '../../libs/api.request'

export function query (data) {
  return axios.request({
    url: '/export/list',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/components/data/dataImportApi.js